import providerProfileTransformer from '../../transformers/providerProfile';
import axios from 'axios';

export default (query) => {
  const promise = new Promise((resolve, reject) => {
    let params = query || {};
    axios.get(process.env.VUE_APP_API_ADMIN_LOCATION + 'providers', { params }).then(
      ({ data }) => {
        let profiles = [];
        if (data.data) {
          profiles.data = providerProfileTransformer.fetchCollectionForTable(data.data);
          profiles.pagination = data.pagination;
        }
        resolve(profiles);
      },
      (error) => {
        reject(error);
      }
    );
  });

  return promise;
};
